module.exports = __webpack_public_path__ + "img/Core_s5_b4_0_1_C00_UK.c14e6a20.png";